import React, { useContext } from 'react'
import ErrorNotice from 'components/ErrorComponents/ErrorNotice'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { apiContext } from 'services/ApiContext'

const ErrorPage = ({ errorId, buttonFunc, reportBug }) => {
  const { isAuthenticated } = useContext(apiContext)
  const { push } = useHistory()

  return (
    <ErrorNotice
      isAuthenticated={isAuthenticated}
      navigate={push}
      reportBug={reportBug}
      id={errorId}
      buttonFunc={buttonFunc}
    />
  )
}

ErrorPage.defaultProps = {
  reportBug: true,
  errorId: 'errorPage',
}

ErrorPage.propTypes = {
  reportBug: PropTypes.bool,
  errorId: PropTypes.string,
  buttonFunc: PropTypes.func,
}

export default ErrorPage
